
import styles from "../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getReceiptsData, PostReceiptsData, DeleteReceiptsData, PatchReceiptsData, DeleteFileData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import ReceiptsOrder from "./components/ReceiptsOrder"
import { Icon } from '../../../components/UnvUI/Icons'

const ReceiptsContent = ({ render, setRender, datacheck, id }) => {
  const { t } = useTranslation('common')

  const componentRef = useRef();
  const [openModal, setOpenModal] = useState(false);
  const [openModalOrder, setOpenModalOrder] = useState(false);

  const [item_data, setItemData] = useState([]);

  const setOpenModalOrderFun = (item) => {
    setOpenModalOrder(true);
    setItemData(item);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getReceiptsData(id, data);
      setData(response.data);

    } catch (error) {
    }
  };
  const [amount, setAmount] = useState("");
  const [source, setSource] = useState("");
  const [order, setOrder] = useState("");

  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [files_data, setFiles] = useState(null);

  const onFileChange = (event) => {
    setFiles(event.target.files);

  };

  const [selectedCheckId, setCheckID] = useState("");

  const handleSelectCheckById = (id) => {
    setCheckID(id);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!amount) {
      setNotify({
        isOpen: true,
        message: "Введите сумму поступления!",
        type: "error",
      });

    }
    else if (!source) {
      setNotify({
        isOpen: true,
        message: "Введите источник поступления!",
        type: "error",
      });

    }
    else if (!selectedCheckId) {
      setNotify({
        isOpen: true,
        message: "Выберите основание поступления!",
        type: "error",
      });

    }
    else if (!order) {
      setNotify({
        isOpen: true,
        message: "Введите номер приходного ордера!",
        type: "error",
      });

    }

    else if (!date) {
      setNotify({
        isOpen: true,
        message: "Введите дату поступления!",
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      formData.append('amount', amount);
      formData.append('source', source);
      formData.append('checkmodel', selectedCheckId);
      formData.append('order', order);

      formData.append('date', date);
      formData.append('description', description);
      if (files_data && files_data.length > 0) {
        for (let i = 0; i < files_data.length; i++) {
          formData.append('files', files_data[i]);
        }
      }
      let data = await PostReceiptsData(id, formData);

      getData();

      setAmount("");
      setSource("");
      setCheckID("");
      setOrder("");
      setDate("");
      setDescription("");
      setFiles(null)
      setOpenModal(false)

      setNotify({
        isOpen: true,
        message: "Поступление успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {

    getData(id);

    setRender(false);


  }, [render]);
  const [searchBase, setSearchBase] = useState('');
  const [searchSource, setSearchSource] = useState('');
  const [searchAmount, setSearchAmount] = useState('');
  const [searchOrder, setSearchOrder] = useState('');

  const [searchDescription, setSearchDescription] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  function convertToISO(dateStr) {
    const [day, month, year] = dateStr.split('.');
    return `${year}-${month}-${day}`;
  }

  const [searchCheck, setSearchCheck] = useState("");

  const setSearchCheckById = (id) => {
    setSearchCheck(id);
  };

  const filteredData = Array.isArray(data)
    ? data.filter((item) => {
      const matchSource = item.source?.toLowerCase().includes(searchSource.toLowerCase());
      const matchAmount = item.amount?.toString().includes(searchAmount);

      const matchCheck = !searchCheck || item.checkmodel === Number(searchCheck);

      const matchOrder = item.order?.toLowerCase().includes(searchOrder.toLowerCase());
      const matchDescription = item.description?.toLowerCase().includes(searchDescription.toLowerCase());

      const itemDateISO = convertToISO(item.date);

      const fromOk = !dateFrom || itemDateISO >= dateFrom;
      const toOk = !dateTo || itemDateISO <= dateTo;

      return matchSource && matchCheck && matchOrder && matchAmount && matchDescription && fromOk && toOk;
    })
    : [];


  const clearFilters = () => {
    setSearchSource('');
    setSearchAmount('');
    setSearchDescription('');
    setSearchBase('');
    setDateFrom('');
    setDateTo('');

    setSearchCheckData("");
    setSearchCheck('');
    setSearchOrder('');
    setCurrentPage(1); 
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalAmount = currentItems
    .reduce((sum, item) => sum + Number(item.amount), 0)
    .toFixed(2);


  const [editRowId, setEditRowId_Set] = useState(null);
  const [amount_edit, setAmountEdit] = useState('');
  const [source_edit, setSourceEdit] = useState('');

  const [order_edit, setOrderEdit] = useState('');
  const [description_edit, setDescriptionEdit] = useState('');
  const [date_edit, setDateEdit] = useState('');
  const [files_data_edit, setFilesDataEdit] = useState([]);
  const [selectedCheckId_edit, setCheckID_edit] = useState("");

  const handleSelectCheckByIdEdit = (id) => {
    setCheckID(id);
  };

  const [searchCheck_editnew, setSearchCheck_editnew] = useState('');
  const [searchBase_editnew, setSearchBase_editnew] = useState('');

  const handleCheckInput_editnew = (value) => {
    setSearchCheck_editnew(value);

    const matchedItem = datacheck.find(item =>
      item.check_data.toLowerCase() === value.toLowerCase()
    );

    if (matchedItem) {
      handleSelectCheckByIdEdit(matchedItem.id);
      setSearchBase_editnew(matchedItem.base); 
    } else {
      handleSelectCheckByIdEdit('');
    }
  };

  const handleBaseInput_editnew = (value) => {
    setSearchBase_editnew(value);

    const matchedItem = datacheck.find(item =>
      item.base.toLowerCase() === value.toLowerCase()
    );

    if (matchedItem) {
      handleSelectCheckByIdEdit(matchedItem.id);
      setSearchCheck_editnew(matchedItem.check_data); 
    } else {
      handleSelectCheckByIdEdit('');
    }
  };

  const filteredChecks_editnew = datacheck?.filter(item =>
    item.check_data.toLowerCase().includes(searchCheck_editnew.toLowerCase())
  );

  const filteredBases_editnew = datacheck?.filter(item =>
    item.base.toLowerCase().includes(searchBase_editnew.toLowerCase())
  );


  const setEditRowId = (item) => {
    setAmountEdit(item.amount)
    setSourceEdit(item.source)
    setDescriptionEdit(item.description)
    handleSelectCheckByIdEdit(item.checkmodel)
    setOrderEdit(item.order)
    setFilesDataEdit([])
    setDateEdit('')
    setEditRowId_Set(item.id)
  };

  const onFileChangeEdit = (e) => {
    setFilesDataEdit([...e.target.files]);
  };
  const onDelete = async (id) => {
    let data = await DeleteReceiptsData(id);
    setNotify({
      isOpen: true,
      message: "Поступление успешно удалено!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };
  const onDeleteFile = async (id) => {
    let data = await DeleteFileData(id);
    setNotify({
      isOpen: true,
      message: "Файл успешно удален!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };
  const onSave = async (id) => {
    const formData = new FormData();
    formData.append('amount', amount_edit);
    formData.append('source', source_edit);
    formData.append('checkmodel', selectedCheckId_edit);
    formData.append('order', order_edit);

    if (date_edit) {
      formData.append('date', date_edit);
    }
    formData.append('description', description_edit);
    if (files_data_edit && files_data_edit.length > 0) {
      for (let i = 0; i < files_data_edit.length; i++) {
        formData.append('files', files_data_edit[i]);
      }
    }
    let data = await PatchReceiptsData(id, formData);


    getData()
    setAmountEdit("");
    setSourceEdit("");
    setOrderEdit("");
    setDateEdit("");
    setCheckID_edit("");
    setDescriptionEdit("");
    setFilesDataEdit(null)
    setOpenModal(false)
    setSearchBase('');

    setSearchCheckData("");
    clearFilters()
    setNotify({
      isOpen: true,
      message: "Поступление успешно изменено!",
      type: "success",
      sound: "success"
    });
    setRender(true)
    setEditRowId_Set(null);
  };

  const [searchCheckData, setSearchCheckData] = useState("");
  const handleCheckChange = (value) => {
    setSearchCheck(value);

    const found = datacheck.find(
      (item) => item.check_data?.toLowerCase() === value.toLowerCase()
    );

    if (found) {
      setSearchCheck(found.id);
      setSearchCheckData(found.check_data); 
      setSearchBase(found.base); 
    } else {
      setSearchCheck('');
    }
  };

  const handleBaseChange = (value) => {
    setSearchBase(value);

    const found = datacheck.find(
      (item) => item.base?.toLowerCase() === value.toLowerCase()
    );

    if (found) {
      setSearchCheck(found.id);
      setSearchCheckData(found.check_data); 
      setSearchBase(found.base); 
    } else {
      setSearchCheck('');
    }
  };


  return (
    <>

      <div className={styles.content_header}>

        <h2 className={styles.project__h}>{t('auto.components_receiptscontent.k1')}</h2>
        <button className={styles.btn_print} onClick={handlePrint}>{t('auto.components_academicyearcontent.k1')} </button>


        <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
          Добавить поступление
        </Button>
      </div>

      <div className={styles.div_search}>
        <h2 className={styles.project__h}>{t('common.filter')}</h2>
        <div>
          <div>
            <input
              type="text"
              placeholder={t('auto.components_expensescontent.k5')}
              value={searchAmount}
              onChange={(e) => setSearchAmount(e.target.value)}
            />
            <input
              type="text"
              placeholder={t('auto.components_receiptscontent.k3')}
              value={searchSource}
              onChange={(e) => setSearchSource(e.target.value)}
              style={{ marginRight: '10px' }}
            />

            <input
              type="text"
              placeholder={t('auto.components_expensescontent.k7')}
              value={searchOrder}
              onChange={(e) => setSearchOrder(e.target.value)}
              style={{ marginRight: '10px' }}
            />
            <input
              type="text"
              placeholder={t('auto.components_expensescontent.k8')}
              value={searchDescription}
              onChange={(e) => setSearchDescription(e.target.value)}
            />
          </div>
          <div>
            От
            <input
              type="date"
              placeholder={t('auto.components_expensescontent.k9')}
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
            До
            <input
              type="date"
              placeholder={t('auto.components_expensescontent.k10')}
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>
          <Button onClick={clearFilters} className={styles.clear__button} >
            Очистить
          </Button>
        </div>
        <div className={styles.div_check_search}>
          <div>
            <label>{t('auto.components_checkcontent.k2')}</label>
            <input
              type="text"
              value={searchCheckData}
              onChange={(e) => handleCheckChange(e.target.value)}
              list="checkOptions"
              placeholder={t('auto.components_expensescontent.k11')}
            />
            <datalist id="checkOptions">
              {Array.isArray(datacheck) &&
                datacheck.map((item) => (
                  <option key={item.id} value={item.check_data} />
                ))}
            </datalist>
          </div>

          <div>
            <label>{t('pages.ordersPage.ground_field')}</label>
            <input
              type="text"
              value={searchBase}
              onChange={(e) => handleBaseChange(e.target.value)}
              list="baseOptions"
              placeholder={t('auto.components_expensescontent.k12')}
            />
            <datalist id="baseOptions">
              {Array.isArray(datacheck) &&
                datacheck.map((item) => (
                  <option key={item.id} value={item.base} />
                ))}
            </datalist>
          </div>
        </div>


      </div>

      <table ref={componentRef} className={styles.table__wrapper}>
        <thead className={styles.table__head}>
          <tr className={styles.table__row}>
            <th className={styles.table__item}>№</th>

            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('dorm.field_amount')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('auto.components_expensescontent.k2')} </span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('plagiarism.source')} </span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('auto.components_checkcontent.k5')} </span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('pages.ordersPage.ground')} </span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('assignments.description_label')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('auto.components_receiptscontent.k2')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('auto.components_expensescontent.k4')}</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>{t('common.file')}</span>
            </th>
            <th className={styles.table__item__nav} >
              <span className={styles.table__title}>{t('common.actions')}</span>
            </th>
          </tr>
        </thead>

        <tbody className={styles.table__body}>
          {currentItems.map((item, index) => (

            <tr className={styles.table__row} key={item.id}>
              <td className={styles.table__item}>
                <span className={styles.table__title}>
                  {index + 1 + (currentPage - 1) * itemsPerPage}
                </span>
              </td>
              {editRowId === item.id ? (
                <>
                  <td className={styles.table__item}>
                    <input
                      type="number"
                      value={amount_edit}
                      onChange={(e) => setAmountEdit(e.target.value)}
                      placeholder={t('auto.components_expensescontent.k13')}
                      className={styles.edit_input}
                    />
                  </td>
                  <td className={styles.table__item}>
                    <input
                      type="text"
                      value={order_edit}
                      onChange={(e) => setOrderEdit(e.target.value)}
                      placeholder={t('auto.components_receiptscontent.k4')}
                      className={styles.edit_input}
                    />
                  </td>

                  <td className={styles.table__item}>
                    <input
                      type="text"
                      value={source_edit}
                      onChange={(e) => setSourceEdit(e.target.value)}
                      placeholder={t('plagiarism.source')}
                      className={styles.edit_input}
                    />
                  </td>
                  <td className={styles.table__item}>
                    <div className={styles.div_check_edit}>
                      <div>

                        <select value={selectedCheckId_edit} onChange={(e) => handleSelectCheckByIdEdit(e.target.value)}>
                          <option value="">{t('auto.components_checkcontent.k3')}</option>
                          {Array.isArray(datacheck) && datacheck.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.check_data}
                            </option>
                          ))}
                        </select>
                      </div>

                    </div>
                  </td>
                  <td className={styles.table__item}>
                    <div className={styles.div_check_edit}>

                      <div>

                        <select value={selectedCheckId_edit} onChange={(e) => handleSelectCheckByIdEdit(e.target.value)}>

                          {Array.isArray(datacheck) && datacheck.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.base}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </td>
                  <td className={styles.table__item}>
                    <textarea
                      value={description_edit}
                      onChange={(e) => setDescriptionEdit(e.target.value)}
                      placeholder={t('assignments.description_label')}
                      className={styles.edit_textarea}
                    />
                  </td>
                  <td className={styles.table__item}>
                    <input

                      type="date"
                      value={date_edit}
                      onChange={(e) => setDateEdit(e.target.value)}
                      className={styles.edit_input}
                    />
                  </td>
                  <td className={styles.table__item}>{item.date_сreate}</td>
                  <td className={styles.table__item}>
                    <input
                      type="file"
                      multiple
                      onChange={onFileChangeEdit}
                      id="file-upload"
                      className={styles.file_upload_input}
                    />
                    <label htmlFor="file-upload" className={styles.file_upload_label}>
                      {files_data_edit?.length ? `Загружено: ${files_data_edit.length}` : 'Загрузите файлы'}
                    </label>
                  </td>
                  <td className={styles.table__item__nav} >
                    <div className={styles.table__item__div}>
                      <button onClick={() => onSave(item.id)} className={styles.saveBtn}><Icon name="save" /> </button>
                      <button onClick={() => setEditRowId_Set(null)} className={styles.cancelBtn}>
                        <Icon name="close" />
                      </button>
                      <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}><Icon name="delete" /></button>
                    </div>
                  </td>

                </>
              ) : (
                <>
                  <td className={styles.table__item}>
                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                      {item.amount}
                    </span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.order}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.source}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.check}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.check_base}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.description}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.date}</span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.date_сreate}</span>
                  </td>
                  <td className={styles.table__item}>
                    <div className={styles.table__fileList}>
                      {item.documents.map((doc, index) => {
                        const name = doc.file.split('/').pop();
                        const short = name.length > 15 ? name.slice(0, 15) + '…' : name;
                        return (
                          <div className={styles.table__fileDiv}>
                            <a
                              key={index}
                              href={doc.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.table__fileButton}

                            >
                              {short}
                            </a>
                            <button onClick={() => onDeleteFile(doc.id)} className={styles.deleteBtn}><Icon name="delete" /></button>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  <td className={styles.table__item}>
                    {item.source === "Контракт" ? ("") : (
                      <div className={styles.table__item__div}>
                        <button onClick={() => setEditRowId(item)} className={styles.editBtn}><Icon name="edit" /> </button>
                        <button onClick={() => setOpenModalOrderFun(item)} className={styles.editBtn}><Icon name="print" /></button>
                      </div>
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}

          
          <tr className={styles.table__row}>

            <td className={styles.table__item} style={{ fontWeight: 'bold' }}>
              Итого: {totalAmount}
            </td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
            <td className={styles.table__item}></td>
          </tr>
        </tbody>
        <div className={styles.pagination}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              style={{
                padding: '5px 10px',
                background: currentPage === page ? '#736CED' : '#f0f0f0',
                color: currentPage === page ? '#fff' : '#000',
                border: '1px solid #ccc',
                borderRadius: "6px",
                cursor: 'pointer',
              }}
            >
              {page}
            </button>
          ))}
        </div>


      </table>
      <ModalWindow
        openModal={openModalOrder}
        setOpenModal={setOpenModalOrder}
        modalText={'Приходной ордер'}

      >
        <div  >
          <ReceiptsOrder setOpenModalOrder={setOpenModalOrder} item={item_data} ></ReceiptsOrder>
        </div>
      </ModalWindow>
      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalTitle={'Новое поступление'}
        modalText={'Заполните данные для регистрации поступления денежных средств'}
      >
        <form onSubmit={handleSubmit} className={styles.modal_form}>
          <div className={styles.div_check}>
            <div>
              <label htmlFor="recv-check">{t('auto.components_checkcontent.k2')}</label>
              <input
                id="recv-check"
                list="check-options-editnew"
                value={searchCheck_editnew}
                onChange={(e) => handleCheckInput_editnew(e.target.value)}
                placeholder={t('auto.components_expensescontent.k15')}
                autoComplete="off"
              />
              <datalist id="check-options-editnew">
                {filteredChecks_editnew?.map(item => (
                  <option key={item.id} value={item.check_data} />
                ))}
              </datalist>
            </div>
            <div>
              <label htmlFor="recv-base">{t('pages.ordersPage.ground_field')}</label>
              <input
                id="recv-base"
                list="base-options-editnew"
                value={searchBase_editnew}
                onChange={(e) => handleBaseInput_editnew(e.target.value)}
                placeholder={t('auto.components_expensescontent.k16')}
                autoComplete="off"
              />
              <datalist id="base-options-editnew">
                {filteredBases_editnew?.map(item => (
                  <option key={item.id} value={item.base} />
                ))}
              </datalist>
            </div>
          </div>

          <div className={styles.form_input}>
            <div>
              <label htmlFor="recv-amount">Сумма поступления</label>
              <input
                id="recv-amount"
                type="number"
                step="0.01"
                placeholder={t('auto.components_expensescontent.k17')}
                value={amount}
                name="amount"
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="recv-source">Источник</label>
              <input
                id="recv-source"
                type="text"
                placeholder={t('auto.components_receiptscontent.k5')}
                value={source}
                name="source"
                onChange={(e) => setSource(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="recv-order">Номер ордера</label>
              <input
                id="recv-order"
                type="text"
                placeholder={t('auto.components_receiptscontent.k6')}
                value={order}
                name="order"
                onChange={(e) => setOrder(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="recv-date">Дата поступления</label>
              <input
                id="recv-date"
                type="date"
                value={date}
                name="date"
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label htmlFor="recv-desc">Описание</label>
            <textarea
              id="recv-desc"
              placeholder={t('main.description_placeholder')}
              value={description}
              name="description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className={styles.add_statement_file}>
            <input
              type="file"
              id="file-upload"
              multiple
              className={styles.file_upload_input}
              onChange={onFileChange}
            />
            <label htmlFor="file-upload" className={styles.file_upload_label}>
              {files_data ? <>Вы загрузили: {files_data.length} файлов</> : 'Загрузите файлы'}
            </label>
          </div>

          <div className={styles.create_footer}>
            <Button
              type="button"
              onClick={() => setOpenModal(false)}
              className={styles.close_btn_sub}
            >
              Закрыть
            </Button>
            <button
              type="submit"
              className={styles.open_btn_sub}
            >
              {t('common.create')}
            </button>
          </div>
        </form>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />


    </>


  );
};

export default ReceiptsContent;
